import React, { Fragment } from "react";
import { IContext, RequestStatus } from "../../../logic/api";
import styles from "../viewer/components/styles";

interface IAPIHookResult<R, P> {
  data: R | null,
  status: RequestStatus,
  err: Error | unknown | null,
  send: (context: IContext, parameters: P, callBack: (results: R | null) => void) => void;
}

interface IEmpty {
  empty: number;
}

interface IRecordWithStyle {
  style: string;
}

export function renderHeader<T>(
  hook: IAPIHookResult<unknown[], T>,
  items: unknown[],
): JSX.Element {
  const item = items[0];
  if (item == null) {
    return <Fragment />;
  }
  const keys = Object.keys(item as IEmpty);
  const styleIndex = keys.indexOf("style");
  return <tr>
    {keys.map((key, i) => {
      if (key == "style") {
        return <Fragment key={i}></Fragment>
      }
      const columnStyle = (i == 0 || (i == styleIndex + 1 && styleIndex == 0)) ? styles.thFirst : styles.th;
      return <th style={columnStyle} key={i}><b>{key}</b></th>
    })}
  </tr>
}

export const renderItem = (item: unknown) => {
  const keys = Object.keys(item as IEmpty);
  const values = Object.values(item as IEmpty);
  const styleIndex = keys.indexOf("style");

  return <tr>
    {keys.map((key, i) => {
      if (key == "style") {
        return <Fragment key={i}></Fragment>
      }
      const value = values[i];
      let tdstyle = (i == 0 || (i == styleIndex + 1 && styleIndex == 0)) ? styles.tdFirst : styles.td

      const styleName = (item as IRecordWithStyle)["style"];
      if (styleName != null && styleName != "") {
        const styleCss: unknown = (styles as Record<string, unknown>)[styleName];
        tdstyle = { ...tdstyle, ...(styleCss as Record<string, unknown>) };
      }

      return <td key={i} style={tdstyle}>{value}</td>
    })}
  </tr>
}
